/**
 * Toggle an option id in a checkbox list value array.
 * @param {string[]} values - Current selected option ids
 * @param {string} optionId - Option id to toggle
 * @returns {string[]} Updated selected ids
 */
export function toggleCheckboxValue(values, optionId) {
  const id = String(optionId);
  const current = Array.isArray(values) ? values.map(String) : [];
  if (current.includes(id)) {
    return current.filter((v) => v !== id);
  }
  return [...current, id];
}

/**
 * Whether an option is checked.
 * @param {string[]} values - Current selected option ids
 * @param {string} optionId - Option id
 * @returns {boolean}
 */
export function isOptionChecked(values, optionId) {
  const current = Array.isArray(values) ? values.map(String) : [];
  return current.includes(String(optionId));
}

/**
 * Whether a cell has any displayable content.
 * @param {CheckboxListCell} cell
 * @returns {boolean}
 */
export function hasCellContent(cell) {
  if (!cell) return false;
  return Boolean(cell.icon || cell.imageUrl || cell.lib);
}

/**
 * Plain-text fallback for option label (aria / title).
 * @param {CheckboxListCell[]} cells
 * @returns {string}
 */
export function getOptionLabelText(cells) {
  if (!Array.isArray(cells)) return '';
  return cells
    .map((cell) => cell?.lib || '')
    .filter(Boolean)
    .join(' ');
}
